export default __webpack_public_path__ + "static/media/image.apex-qs-solutions-aqss-.9c27e100.png";